import { hideLaunchEditOnMobile } from '~commonInfra/utils/MobileHelper';
import { Messages } from '~src/codegen/Localize';
import { newWorkbookForPublishedConnection } from '~src/publishedConnection/actions/NewWorkbookForPublishedConnectionAction';
import { EntityActionNames,IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { ILaunchWebAuthoringAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { newWorkbookForDatasource } from '../actions/NewWorkbookForDatasourceAction';


export const NewWorkbookEntityAction: IEntityAction<IContentInfo<'datasource' | 'virtualConnection'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.NewWorkbook,
  translateName: Messages.newWorkbook,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems) && !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.launchWebAuthoring,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newWorkbookForDatasource(item);
    } else if (item.contentType === 'virtualConnection') {
      return newWorkbookForPublishedConnection(item);
    }
  }
};
